export default [
    {name:'BROKER', description: 'Peering status events between Zeek or Broker-enabled processes'},
    {name:'CAPTURE LOSS', description: 'Packet loss rate'},
    {name:'CLUSTER', description: 'Zeek cluster messages'},
    {name:'CONFIG', description: 'Configuration option changes'},
    {name:'CONN', description: 'TCP/UDP/ICMP connections'},
    {name:'DCE RPC', description: 'Distributed Computing Environment/RPC'},
    {name:'DHCP', description: 'DHCP leases'},
    {name:'DNP3', description: 'DNP3 requests and replies'},
    {name:'DNS', description: 'DNS activity'},
    {name:'DPD', description: 'Dynamic protocol detection failures'},
    {name:'FILES', description: 'File analysis results'},
    {name:'FTP', description: 'FTP activity'},
    {name:'HTTP', description: 'HTTP requests and replies'},
    {name:'INTEL', description: 'Intelligence data matches'},
    {name:'IRC', description: 'IRC commands and responses'},
    {name:'KERBEROS', description: 'Kerberos'},
    {name:'KNOWN CERTS', description: 'SSL certificates'},
    {name:'KNOWN HOSTS', description: 'Hosts that have completed TCP handshakes'},
    {name:'KNOWN MODBUS', description: 'Modbus masters and slaves'},
    {name:'KNOWN SERVICES', description: 'Services running on hosts'},
    {name:'LOADED SCRIPTS', description: 'Shows all scripts loaded by Zeek'},
    {name:'MODBUS', description: 'Modbus commands and responses'},
    {name:'MODBUS REGISTER CHANGE', description: 'Tracks changes to Modbus holding registers'},
    {name:'MYSQL', description: 'MySQL'},
    {name:'NETCONTROL', description: 'NetControl actions'},
    {name:'NETCONTROL CATCH RELEASE', description: 'NetControl catch and release actions'},
    {name:'NETCONTROL DROP', description: 'NetControl actions'},
    {name:'NETCONTROL SHUNT', description: 'NetControl shunt actions'},
    {name:'NOTICE', description: 'Zeek notices'},
    {name:'NOTICE ALARM', description: 'The alarm stream'},
    {name:'NTLM', description: 'NT LAN Manager (NTLM)'},
    {name:'OCSP', description: 'Online Certificate Status Protocol (OCSP). Only created if policy script is loaded.'},
    {name:'OPENFLOW', description: 'OpenFlow debug log'},
    {name:'PACKET FILTER', description: 'List packet filters that were applied'},
    {name:'PE', description: 'Portable Executable (PE)'},
    {name:'PROF', description: 'Profiling statistics (to create this log, load policy/misc/profiling.zeek)'},
    {name:'RADIUS', description: 'RADIUS authentication attempts'},
    {name:'RDP', description: 'RDP'},
    {name:'REPORTER', description: 'Internal error/warning/info messages'},
    {name:'RFB', description: 'Remote Framebuffer (RFB)'},
    {name:'SIGNATURES', description: 'Signature matches'},
    {name:'SIP', description: 'SIP'},
    {name:'SMB CMD', description: 'SMB commands'},
    {name:'SMB FILES', description: 'SMB files'},
    {name:'SMB MAPPING', description: 'SMB trees'},
    {name:'SMTP', description: 'SMTP transactions'},
    {name:'SNMP', description: 'SNMP messages'},
    {name:'SOCKS', description: 'SOCKS proxy requests'},
    {name:'SOFTWARE', description: 'Software being used on the network'},
    {name:'SSH', description: 'SSH connections'},
    {name:'SSL', description: 'SSL/TLS handshake info'},
    {name:'STATS', description: 'Memory/event/packet/lag statistics'},
    {name:'STDERR', description: 'Captures standard error when Zeek is started from ZeekControl'},
    {name:'STDOUT', description: 'Captures standard output when Zeek is started from ZeekControl'},
    {name:'SYSLOG', description: 'Syslog messages'},
    {name:'TRACEROUTE', description: 'Traceroute detection'},
    {name:'TUNNEL', description: 'Tunneling protocol events'},
    {name:'UNIFIED2', description: 'Interprets Snort’s unified output'},
    {name:'WEIRD', description: 'Unexpected network-level activity'},
    {name:'WEIRD STATS', description: 'Statistics about unexpected activity'},
    {name:'X509', description: 'X.509 certificate info'},
];
